import * as v from 'valibot';
import { integerInRange } from '../util/valibot';
export const transmitterKindSchema = v.union([
    v.literal('onoff'),
    v.literal('dim'),
    v.literal('rollershade'),
    v.literal('garage'),
]);
export const transmitterSchema = v.object({
    id: integerInRange(0, 0xffffffff),
    kind: transmitterKindSchema,
    title: v.string(),
    comment: v.string(),
    code: integerInRange(0, 0x3ffffff),
    unit: integerInRange(0, 15),
});
export function transmitterKindLabel(kind) {
    switch (kind) {
        case 'onoff': return 'På/Av';
        case 'dim': return 'Dimmer';
        case 'rollershade': return 'Rullgardin';
        case 'garage': return 'Garage';
        default: return '';
    }
}
